import { colorPalette } from '../../ui-blocks/ColorPalette';

export const baseVideoStyles = {
	slider: {
		'&.MuiSlider-root': {
			borderRadius: '15px',
			color: colorPalette.rainbowBlue,
			padding: '0',
			'& .MuiSlider-rail': {
				backgroundColor: colorPalette.dark1,
			},
			'& .MuiSlider-track': {
				border: 'none',
				borderRadius: '15px',
			},
			'& .MuiSlider-thumb': {
				boxShadow: 'none',
				height: '12px',
				width: '12px',
				backgroundColor: 'colors.black',
				borderRadius: '15px',
				borderColor: 'colors.blue3',
				borderStyle: 'solid',
				borderWidth: '2px',
			},
		},
	},
	videoAssetButtonContainer: {
		position: 'absolute',
		backgroundColor: 'transparent',
		zIndex: 6,
		visibility: 'visible',
		width: 'auto',
		height: 'auto',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	videoAssetHoverButtons: {
		backgroundColor: 'transparent',
		transition: 'opacity 0.2s ease-in-out',
		minWidth: 0,
		padding: '16px',
		paddingBottom: '12px',
		minHeight: 0,
		cursor: 'pointer',
		'&: hover': {
			opacity: 0.4,
		},
		'& svg': {
			width: 16,
			height: 16,
			color: colorPalette.light1,
		},
	},
};
